import React from "react";
import profile_Img from "../../Assets/Images/user.png";
import { GoPersonAdd } from "react-icons/go";

const ContactUserList = ({
  key,
  chat,
  moreNewChat,
  setMoreNewChat,
  setActiveChat,
  setCreateChatId,
  setIsMessageLoading,
  setShowProfileView,
}) => {
  return (
    <>
      <li
        onClick={() => {
          setShowProfileView(false);
          setIsMessageLoading(true);
          setCreateChatId(chat._id);
          setMoreNewChat(false);
        }}
        className={`relative flex justify-between items-center p-3 px-4 mt-2 rounded-xl transition-all cursor-pointer 
        ${!moreNewChat ? "bg-white shadow-sm" : "bg-transparent hover:bg-white hover:shadow-sm"}
      `}
        key={key}
      >
        <div className="flex">
          <img
            src={chat?.avtarImage || chat?.userImage || profile_Img}
            alt={chat.name}
            className={`${
              chat?.avtarImage || chat?.userImage
                ? "max-w-[46px] max-h-[46px] rounded-full min-w-[46px] min-h-[46px] object-cover"
                : "object-cover max-w-[46px] max-h-[46px] p-1 rounded-full"
            }`}
          />
          <div className="flex flex-col ml-2">
            <span className="font-semibold text-sm text-zinc-900 pb-2 w-80 truncate">
              {chat?.name}
            </span>
            <span className="text-xs font-normal text-zinc-500 line-clamp-2 overflow-hidden text-ellipsis break-words">
              {moreNewChat &&
                (chat?.privacy === "Everyone" ||
                  chat?.privacy === "Friends") && (
                  <>
                    (
                    {chat?.countryCode?.includes("+")
                      ? chat?.countryCode
                      : `+${chat?.countryCode}`}
                    ) {chat?.phone}
                  </>
                )}
            </span>
          </div>
        </div>

        {/* {!moreNewChat &&
        createNewGroupSection !== 1 &&
        ![1, 2, 3, 4].includes(createNewChannelSection) && (
          <div className="flex flex-col items-end">
            <span className="text-xs pb-2 text-[#06B300]">{chat.time}</span>
            <span className="bg-[#06B300] text-white text-xs flex items-center justify-center rounded-md h-4 w-4 font-semibold">
              {chat.count}
            </span>
          </div>
        )} */}
        <div className="absolute right-4">
          <GoPersonAdd className="text-2xl mb-1 text-[var(--primary-color)]" />
        </div>
      </li>
    </>
  );
};

export default ContactUserList;
